import {Injectable} from '@angular/core';
import {HttpErrorHandler, Priority} from '@spartacus/core';
import {HttpStatusCode} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class InternalServerErrorHandler extends HttpErrorHandler {
  responseStatus = HttpStatusCode.InternalServerError;

  handleError(): void {
    // empty error handler to avoid the default global messages
  }

  getPriority?(): Priority {
    return Priority.NORMAL;
  }
}
